<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" content="发货"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">

			<el-form-item label="商品名称">
				<el-input v-model="name" placeholder="请输入商品名称" readonly></el-input>
			</el-form-item>
			<el-form-item label="快递公司">
				 <el-select v-model="item.shipName" clearable placeholder="请选择快递公司">
				    <el-option
				      v-for="item in options"
				      :label="item.name"
				      :value="item.name">
				    </el-option>
				  </el-select>
			</el-form-item>
			<el-form-item label="订单单号">
				<el-input v-model="item.shipSn" placeholder="请输入订单单号"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit" v-auth="['store/order/sendShip']">发货</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>

		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
				options: [],
				dialogVisible: false,
				name: this.$route.query.name,
				rules: {
					// name: [
					//     {required: true, message: '请输入名称', trigger: 'blur'},
					// ],
				}
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			loadData: function() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.post('/api/common/listLogisticsForSelect', {
					page: this.page,
					limit: this.pageSizeNume
				}).then(res => {
					this.isLoad = !this.isLoad
					this.options = res.data
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},
			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.dialogVisible = false

				this.item.orderProductId = this.id
				this.axios.post('/store/order/sendShip', this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			}
		}
	}
</script>
<style scoped>
</style>
